import { useState } from 'react'

export const useSelectedIds = (
  initialIds?: string[],
): [string[], (id: string) => void, (ids: string[]) => void] => {
  const [selectedIds, setSelectedIds] = useState<string[]>(initialIds || [])

  const onOptionSelected = (id: string) => {
    setSelectedIds(ids => {
      if (ids.includes(id)) {
        return ids.filter(i => i !== id)
      }
      return [...ids, id]
    })
  }

  return [selectedIds, onOptionSelected, setSelectedIds]
}
